const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
      allowGuestAccess: false,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_OAUTH_DOMAIN,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: (process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN || '').split(','),
          redirectSignOut: (process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT || '').split(','),
          responseType: 'code',
          providers: [{ custom: 'Federate' }]
        }
      }
    }
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_S3_BUCKET,
      region: process.env.REACT_APP_S3_REGION
    }
  },
  API: {
    REST: {
      csvReviewApi: {
        endpoint: process.env.REACT_APP_API_ENDPOINT,
        region: process.env.REACT_APP_API_REGION
      }
    },
    generateTestCasesFnUrl: process.env.REACT_APP_GENERATE_TC_FN_URL,
    lambdaFunctionName: process.env.REACT_APP_LAMBDA_FUNCTION_NAME
  }
};

export default awsConfig;
